import React, { useState, useEffect } from "react";
import axios from "axios";
import { post } from "../smartApiService";

interface SdsImageLoaderProps {
  name: string;
  id: string | number;
  url: string;
  containerStyle?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
}

const imageCache: { [key: string]: string } = {}; // Cache to store images in Base64 format

const SdsImageLoader: React.FC<SdsImageLoaderProps> = ({
  name,
  id,
  url,
  containerStyle,
  imageStyle,
}) => {
  const [imageBase64, setImageBase64] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const imageIndex = `${name}_${id}`;

  useEffect(() => {
    const fetchImage = async () => {
      if (imageCache[imageIndex]) {
        setImageBase64(imageCache[imageIndex]);
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const subscription = post(url,{id}).subscribe((response) => {
            if (response.data?.content) {
                const base64Image = response.data.content;
                imageCache[imageIndex] = base64Image; // Cache the image
                setImageBase64(base64Image);
              }
          });
      
          return () => subscription.unsubscribe();
      
      } catch (error) {
        console.error("Error fetching image:", error);
      }
      setIsLoading(false);
    };

    fetchImage();
  }, [id, url, imageIndex]);

  return (
    <div className="sds-image-container box" style={containerStyle}>
      {imageBase64 ? (
        <img
          src={`data:image/png;base64,${imageBase64}`}
          alt={name}
          style={imageStyle}
          className="sds-image image is-256x256"
        />
      ) : null}
    </div>
  );
};

export default SdsImageLoader;
